import classnames from "utilities/classnames";
import styles from "./styles.module.scss";
import { forwardRef } from "react";

type ButtonProps = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
  primary?: boolean;
  secondary?: boolean;
  radius?: "xs" | "sm" | "md" | "lg" | "xl" | "xxl";
  children?: React.ReactNode;
};

export const Button = forwardRef<HTMLButtonElement | null, ButtonProps>((props, ref) => {
  const { children, className, primary, secondary, radius, ...rest } = props;

  const classes = classnames(styles.root, className, {
    [styles.primary]: primary,
    [styles.secondary]: secondary,
    [styles.radius_xs]: radius === "xs",
    [styles.radius_sm]: radius === "sm",
    [styles.radius_md]: radius === "md",
    [styles.radius_lg]: radius === "lg",
    [styles.radius_xl]: radius === "xl",
    [styles.radius_xxl]: radius === "xxl",
  });

  return (
    <button className={classes} {...rest} ref={ref}>
      {children}
    </button>
  );
});
